import { PixelCrop } from 'react-image-crop';

// Constants
import { IMAGES, IMAGE_PROCESSING_MESSAGE } from '@shared/constants';

// Utils
import { urlToBase64 } from '@shared/utils';
import { showErrorToast } from '@/utils/errorHandlers';

/**
 * Convert avatar URL to base64
 * @param avatarUrl - The URL of the avatar to convert
 * @returns Promise<string> - A promise that resolves with the base64 string
 */
export const convertAvatarUrlToBase64 = async (
  avatarUrl?: string,
): Promise<string> => {
  if (!avatarUrl) {
    return IMAGES.AVATAR_DEFAULT_PNG;
  }

  try {
    return await urlToBase64(avatarUrl);
  } catch (error) {
    showErrorToast(IMAGE_PROCESSING_MESSAGE.FETCH_ERROR(String(error)));
    return IMAGES.AVATAR_DEFAULT_PNG;
  }
};

export const getCroppedImg = (
  image: HTMLImageElement,
  crop: PixelCrop,
): Promise<Blob> => {
  const canvas = document.createElement('canvas');
  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;

  canvas.width = crop.width * scaleX;
  canvas.height = crop.height * scaleY;

  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Canvas context not found');

  ctx.drawImage(
    image,
    crop.x * scaleX,
    crop.y * scaleY,
    crop.width * scaleX,
    crop.height * scaleY,
    0,
    0,
    crop.width * scaleX,
    crop.height * scaleY,
  );

  return new Promise((resolve) => {
    canvas.toBlob((blob) => {
      if (blob) resolve(blob);
    }, 'image/png');
  });
};

export function getUpdatedLogoUrl(
  logoUrl?: string | null,
  updatedAt?: string | null,
): string {
  if (!logoUrl) return '';
  if (!updatedAt) return logoUrl;

  const separator = logoUrl.includes('?') ? '&' : '?';
  return `${logoUrl}${separator}updated=${updatedAt}`;
}
